import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';

import { PersonAdd, Search } from '@material-ui/icons';

import { GenericBreadcrumb } from '../atomic/organisms/GenericBreadcrumb';
import { fetchLocalidades } from '../../actions/cbos/localidades';
import { useTraslados } from '../../hooks/useCases/useTraslados';
import { BandejaTraslados } from './Bandeja/BandejaTraslados';
import { CargaSolicitudTraslados } from './Stepper/StepperTraslados';
import { fetchProvincias } from '../../actions/cbos/provincias';
import { GestionSolicitudes } from './GestionSolicitudes/GestionSolicitudes';

export const TrasladosHome = ({ location }) => {
  const dispatch = useDispatch();
  const { get, clean, data, permisos } = useTraslados();

  useEffect(() => {
    clean.solicitudes();
    dispatch(fetchLocalidades());
    dispatch(fetchProvincias());
    get.dim.accesorios();
    get.dim.tiposTraslados();
    get.dim.motivosTraslados();
    get.dim.causasTraslados();
    get.dim.sectoresTraslados();
    get.dim.tipoSolicitudes();
    get.dim.estados();
    get.dim.codigos();
    get.dim.tipoPrestaciones();
    get.dim.tipoTracking();
    get.getByUserSolicitudesTomadas()
    get.tipoDocSolicitudes();

    if(location.state?.idSolicitud) get.solicitud(location.state.idSolicitud)
    if(location.state?.idAfiliado) get.infoAfiliadoSolicitud(location.state.idAfiliado)
  }, []);

  return (
    <GenericBreadcrumb
      breads={[
        {
          init: location.state,
          text: "Ingreso Solicitud",
          Icon: <PersonAdd />,
          filter: permisos.home.breadcrumb.ingreso,
          Component: (
            <>
              {((location.state && data.solicitud !== null) || !location.state) &&
                <CargaSolicitudTraslados 
                  solicitud={data.solicitud} 
                  resetRedirect={() => {
                    location.state = undefined;
                    clean.solicitud();
                  }} 
                />
              }
            </>
            
          )
        },
        {
          text: "Gestion Traslados",
          Icon: <Search />,
          filter: permisos.home.breadcrumb.auditoria,
          Component: (
            <BandejaTraslados />
          )
        }
      ]}
      DefaultComponent={<GestionSolicitudes getByUser />}
    />
  )
}